var _defs, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e69a9dba-f2dd-47e3-8217-ed363a11c855",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1329 635.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fb880a7c-59dc-4486-ac40-ba5b709f930c{font-size:140px;font-family:TwCenMT-Regular, Tw Cen MT;opacity:0.99;}.e0808118-bcd0-4b06-96a2-2a1b39a2eca5,.fb880a7c-59dc-4486-ac40-ba5b709f930c{fill:#fff;}.f8901f6b-065a-4587-a9ec-8b985203cddc{letter-spacing:-0.02em;}.a7166c19-8c43-4fcf-8e9a-3a91d317bf35{letter-spacing:-0.07em;}.e0808118-bcd0-4b06-96a2-2a1b39a2eca5{stroke:#211915;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sin t\xEDtulo-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "fb880a7c-59dc-4486-ac40-ba5b709f930c",
    transform: "translate(97.19 597)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "f8901f6b-065a-4587-a9ec-8b985203cddc"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.44,
    y: 0
  }, "OU"), /*#__PURE__*/React.createElement("tspan", {
    className: "f8901f6b-065a-4587-a9ec-8b985203cddc",
    x: 266.94,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 341.39,
    y: 0
  }, "O SOFT"), /*#__PURE__*/React.createElement("tspan", {
    className: "a7166c19-8c43-4fcf-8e9a-3a91d317bf35",
    x: 788.53,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 918.75,
    y: 0
  }, "ARE"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M793.8,267.91s13,39.13,50.26,97.84,37.27,94.58,12.15,125.57c0,0-.9-27.05-10.94-70.13a210.09,210.09,0,0,0-30.87-70.12c-20.45-30.26-54.54-55.42-142.16-83.16-115.64-36.57-94-123.91-94-123.91S650.35,255.68,793.8,267.91Z",
    transform: "translate(-232 -142.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M803.33,370.86s-20.27-46.06-79.67-64.53c-51.06-15.94-52.08-11.49-104.72-42.41,0,0,15.12,58.48,85.34,73.38C770.51,351.49,803.33,370.86,803.33,370.86Z",
    transform: "translate(-232 -142.76)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M702.63,355.25s32,30.16,72.94,45.4c39.36,14.67,54.58,33.29,54.58,33.29s2-33.34-44.78-57.09C769.27,368.63,747.19,363.72,702.63,355.25Z",
    transform: "translate(-232 -142.76)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M1090.35,355.25s-32,30.16-72.94,45.4c-39.36,14.67-54.56,33.29-54.56,33.29s-2-33.34,44.76-57.09C1023.71,368.63,1045.78,363.72,1090.35,355.25Z",
    transform: "translate(-232 -142.76)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M897.64,463c-.31-.58-27.47,52.93-90.78,78.69,0,0,82.3,80.08,181.55.46C988.41,542.19,928.33,522.53,897.64,463Z",
    transform: "translate(-232 -142.76)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M804.5,196.1c0,56.25,17.82,76.65,17.82,76.65s3.36-20.3,15.73-20.91c40.05-2,57.72,88.52,57.72,88.52s21-84,53.86-89.38c21.88-3.57,22.12,21.89,22.12,21.89s21.71-29.71,16.66-79.54c0,0-84.59,88.4-183.91,0Z",
    transform: "translate(-232 -142.76)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M867.88,294.94s-16.29-33.81-27.42-23.56C828.11,282.76,867.88,294.94,867.88,294.94Z",
    transform: "translate(-232 -142.76)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M925,294.94s16.31-33.81,27.45-23.56C964.8,282.76,925,294.94,925,294.94Z",
    transform: "translate(-232 -142.76)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M1000,267.91S987,307,949.77,365.75s-37.27,94.58-12.15,125.57c0,0,.87-27.05,10.94-70.13a210.09,210.09,0,0,1,30.83-70.12c20.47-30.26,54.53-55.42,142.18-83.16,115.63-36.57,94-123.91,94-123.91S1143.48,255.68,1000,267.91Z",
    transform: "translate(-232 -142.76)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "e0808118-bcd0-4b06-96a2-2a1b39a2eca5",
    d: "M988.41,371.15s20.25-46,79.67-64.57c51.06-16,52.08-11.52,104.69-42.44,0,0-15.1,58.51-85.31,73.5C1021.23,351.8,988.41,371.15,988.41,371.15Z",
    transform: "translate(-232 -142.76)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/All.482d1e5a79e25b7d8b0276fe51fb6904.svg";
export { ForwardRef as ReactComponent };